import * as React from "react";
import {
  EditComponent,
  CreateComponent,
  CustomComponentProps,
} from "src/components/common/Component";

export function ProductCategoryEditComponent(props: CustomComponentProps) {
  const { children } = props;
  return <EditComponent attributes={["name"]} children={children} />;
}

export function ProductCategoryCreateComponent(props: CustomComponentProps) {
  const { children } = props;
  return <CreateComponent source={"Product Category"} children={children} />;
}
